
import { Outlet } from "react-router-dom"
import UrlBackgruound from "../../constans/Constans"
import '../../assets/background.css'
const Background = ({ component }) =>{


    return (<>
    <div className={'background-visit'}>
        {component}
    </div>
    </>)

}

export default Background